module.exports = __webpack_public_path__ + "assets/img/rz6.2366eaf5.png";